export const tabBox = "te468nj";
export const tabWrapper = "tzeeipv";
export const tabfixedWrapper = "t1o9q65d";
export const facetWrapper = "f9pk7cr";
export const bottomShadow = "bnd2i6n";
export const filter = "f1jofsfq";
export const filterCount = "f1q2fmik";

require("./styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./styles.ts");